// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, actions) {
  return {
          driver_incentive_list: actions.driver_incentive_list,
          msisdn: state.msisdn,
          offset: actions.offset,
          end_of_list: actions.end_of_list
        };
}

export {
  reducer ,
  
}
/* No side effect */
